import { ApiSearch } from "../../interfaces/Api";

export interface IKLObservationIdentifierNew {
  macAddress: string;
  antennaDirection: AntennaDirection;
  observationIdentifier: string;
}

export interface IObservationIndetifiersBulkNew {
  dataDefinitions: IKLObservationIdentifierNew[];
  organizationId?: number | string;
  locationId?: number | string;
}

export interface IObservationIdentifier
  extends IKLObservationIdentifierNew, Record<string, any> {
  id: number;
  knownLocationId: number;
  description: string;
  organizationId: number;
  organizationName: string;
}

export interface IObservationIdentifierResponse {
  dataDefinitions: IObservationIdentifier[];
  page: number;
  pageSize: number;
  pages: number;
  total: number;
}

export enum AntennaDirection {
  AntIn = "AntIn",
  AntOut = "AntOut",
}

export enum ObservationIdentifiersSearchTypes {
  Identifier = "Identifier",
  Description = "Description",
}

export interface ObservationIdentifiersSearch extends ApiSearch {
  s?: string;
}
